import { Component, Input, ViewChild } from '@angular/core';
import { ElementRef } from '@angular/core';
@Component({
  selector: 'app-player',
  templateUrl: './player.component.html',
  styleUrls: ['./player.component.scss']
})
export class PlayerComponent {
  @Input() fullScreen: boolean = false;
  @Input() valSelect1Video: any;
  @Input() videoUrl?: string;


  @ViewChild('videoElement') videoElementRef?: ElementRef;
  private player: any;
  myButtonDom: any;

}
